<div class="mct-flex mct-col"  *ngFor="let eventDate of eventDateTimes; let i = index">
  <div class="mb-10">
    <div class="mct-flex mct-row" >
      <div class="mct-flex mct-col" >
        <label [hidden]="i != 0">{{ 'common.date' | translate | titlecase }}</label>
        <wl-date-selector [disabled]="true" class="mr-10" [name]="'date' + i" [(ngModel)]="eventDate.EventDate"></wl-date-selector>
      </div>
      <div class="mct-flex mct-col" >
        <label [hidden]="i != 0"> {{ 'events.new.component.event-start-time-label' | translate }} </label>
        <wl-time-selector
          [name]="'startTime' + i"
          [(ngModel)]="eventDate.StartTime"
          class="mr-15"
          inputCssClass="form-control"
        ></wl-time-selector>
      </div>
      <div class="mct-flex mct-col" >
        <label [hidden]="i != 0"> {{ 'events.new.component.event-end-time-label' | translate }} </label>
        <wl-time-selector [name]="'endTime' + i" [(ngModel)]="eventDate.EndTime" inputCssClass="form-control"></wl-time-selector>
      </div>
    </div>
  </div>
</div>
